module.exports = __webpack_public_path__ + "static/partners-c21495ed9718579e9f97a642fe6f09bf.png";